import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "../styles/assetchart.css";

const AssetMonthlyBarChart = ({ assets }) => {
  // Process assets data to get monthly counts
  const getMonthlyData = () => {
    const monthlyData = {};
    const currentYear = new Date().getFullYear();

    // Initialize all months with 0 count
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    months.forEach((month) => {
      monthlyData[month] = { month, count: 0 };
    });

    // Count assets by month
    assets.forEach((asset) => {
      if (asset.created_at) {
        const date = new Date(asset.created_at);
        const year = date.getFullYear();

        // Only include current year data
        if (year === currentYear) {
          const monthIndex = date.getMonth();
          const monthName = months[monthIndex];
          monthlyData[monthName].count++;
        }
      }
    });

    return Object.values(monthlyData);
  };

  const chartData = getMonthlyData();

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div className="chart-tooltip">
          <p className="tooltip-label">{label}</p>
          <p className="tooltip-value">Assets Added: {data.value}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="asset-chart-container">
      <h2 className="chart-title">Assets Added By Month</h2>
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis
              dataKey="month"
              tick={{ fontSize: 12, fill: "#666" }}
              axisLine={{ stroke: "#ccc" }}
            />
            <YAxis
              tick={{ fontSize: 12, fill: "#666" }}
              axisLine={{ stroke: "#ccc" }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey="count"
              fill="#007bff"
              radius={[4, 4, 0, 0]}
              maxBarSize={50}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AssetMonthlyBarChart;
